import { type JSX, createSignal, createEffect } from 'solid-js';
import { buildAuthImg } from '../../utils/util';

export interface IViewThumbnail {
  id: string;
  name: string;
  thumbnail?: string;
  image?: string;
  createdOn: string;
  createdBy?: {
    firstName: string;
    lastName: string;
  };
}

/**
 * Simple component that starts fetching the view thumbnail and displays it when done.
 * It is only the div with the image, no interaction logic and no 'embedIn3D' conditions.
 */
interface ViewThumbnailProps {
  view: IViewThumbnail;
  accessToken?: string;
  class?: string;
  alt?: string;
}

export function ViewThumbnail(
  props: Readonly<ViewThumbnailProps>
): JSX.Element {
  const [dataUrl, setDataUrl] = createSignal<string>('');

  createEffect(() => {
    const thumbnailUrl = props.view.thumbnail;
    const token = props.accessToken;
    setDataUrl('');
    if (thumbnailUrl) {
      void buildAuthImg(thumbnailUrl, token)
        .then((result) => setDataUrl(result))
        .catch((error) =>
          console.error('Error fetching view thumbnail:', error)
        );
    }
  });

  return (
    <div
      class={`thumbnail ${props.class || ''}`}
      style={{ width: '4.7rem', height: '4.7rem' }}
    >
      {dataUrl() && <img src={dataUrl()} alt={props.alt || props.view.name} />}
    </div>
  );
}
